import React from "react";
import "../../Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import { withTranslation } from "react-i18next";

function CategoryFilter({ categoryList = [], selectedCategory, setCategoryFilter, t }) {
  const handleChange = (e, category) => {
    const id = category?.id ?? category?.Id;
    if (id == null) return;
    const next = e.target.checked
      ? [...(selectedCategory || []), id]
      : (selectedCategory || []).filter((cid) => +cid !== +id);
    setCategoryFilter(next);
  };

  const list = Array.isArray(categoryList) ? categoryList : [];

  return (
    <ul className={["filter-list"]}>
      {list.map((cat) => {
        const id = cat?.id ?? cat?.Id;
        const name = cat?.title ?? cat?.Title ?? cat?.name ?? "";
        if (id == null) return null;
        return (
          <li key={id}>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) => handleChange(e, cat)}
                  checked={selectedCategory?.includes(id)}
                />{" "}
                <span>{name}</span>
              </label>
            </div>
          </li>
        );
      })}
      {list.length === 0 && (
        <li className="text-muted">{t("officePolicyManagement.noCategories") || "No categories"}</li>
      )}
    </ul>
  );
}

export default withTranslation()(CategoryFilter);
